import {
  FormFieldResponseDTO,
  FormFieldTypeDTO,
  FormInferredFieldResponseDTO,
  FormItemResponseDTO,
  FormItemTypeDTO,
} from '@/api/base/DTOs';
import { IFormBase, IFormInput, SingleFormField } from '@/forms/typings';
import { adaptFormFieldResponseToInputFormField } from './input-field.adapter';

/**
 * Inferred fields map to text inputs; when `hidden` is true, {@link SingleFieldPresenter} omits them.
 */
export const adaptFormInferredFieldResponseToSingleFormField = (
  item: FormItemResponseDTO,
  parentFieldId?: IFormBase['fieldId'],
): SingleFormField => {
  const inferred = item as FormInferredFieldResponseDTO;

  const asField: FormFieldResponseDTO = {
    fieldID: inferred.fieldID,
    formItemType: FormItemTypeDTO.Field,
    hasAnyValue: inferred.hasAnyValue,
    notApplicable: inferred.notApplicable,
    showNotApplicable: inferred.showNotApplicable,
    label: inferred.label ?? inferred.name,
    name: inferred.name,
    fieldType: FormFieldTypeDTO.Text,
    readonly: inferred.readonly,
    values: inferred.values,
    itemSize: inferred.itemSize,
    hint: inferred.hint,
    hintImageUrl: inferred.hintImageUrl,
    restriction: inferred.restriction,
    showClearButton: inferred.showClearButton,
    isEditable: inferred.isEditable,
  };

  const input = adaptFormFieldResponseToInputFormField(asField, parentFieldId);
  const withHidden: IFormInput = {
    ...input,
    hidden: inferred.hidden,
  };
  return withHidden;
};
